import styled, { css } from "styled-components/macro";
import { device } from "../../../device";

export const StyledNotificationContainer = styled.div`
  width: 100%;
`;
export const StyledNotification = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  text-align: left;

  padding: 24px;
  width: 100%;
  border-radius: 8px;
  margin-bottom: 8px;

  ${(props) =>
    props.type === "planUsage" &&
    css`
      margin: 40px auto;

      background: #ffffff;
      border: 1px solid #ebedee;
      color: #575e68;
      padding: 24px 63px;
    `};
  ${(props) =>
    props.type === "noStats" &&
    css`
      background: #ffffff;
      border: 1px solid #ebedee;
      color: #575e68;
      padding: 24px 63px;
    `};
  ${(props) =>
    props.type === "gain" &&
    css`
      background: linear-gradient(110.71deg, #05345c -3.16%, #084e8a 107.12%), #cae5fc;
      color: #ffffff;
      padding: 24px 63px;
      @media ${device.mobileL} {
        flex-direction: column;
      }
    `};
  ${(props) =>
    props.type === "success" &&
    css`
      background: #f2f8f5;
      border: 1px solid #008060;
    `};
  ${(props) =>
    props.type === "info" &&
    css`
      background: #ebf9fc;
      border: 1px solid #084e8a;
    `};
  ${(props) =>
    props.type === "warning" &&
    css`
      background: #fff5ea;
      border: 1px solid #c05717;
    `};
  @media ${device.tablet} {
    padding: 1rem;
    ${(props) =>
      props.type === "planUsage" &&
      css`
        margin: 1rem auto;
        padding: 1rem 1.5rem;
      `};
    ${(props) =>
      props.type === "noStats" &&
      css`
        padding: 1rem 1.5rem;
      `};
    ${(props) =>
      props.type === "gain" &&
      css`
        padding: 1rem 1.5rem;
      `};
  }
`;
export const StyledNotificationTitle = styled.h3`
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  opacity: 0.8;

  ${(props) =>
    props.type === "gain" &&
    css`
      color: #ffffff;
      opacity: 1;
      font-weight: 600;
      font-size: 24px;
      line-height: 36px;
      @media ${device.tablet} {
        font-size: 20px;
        line-height: 30px;
      }
    `};

  ${(props) =>
    props.type === "success" &&
    css`
      color: #008060;
    `};

  ${(props) =>
    props.type === "info" &&
    css`
      color: #084e8a;
    `};

  ${(props) =>
    props.type === "warning" &&
    css`
      color: #c05717;
    `};
`;

export const StyledNotificationContent = styled.p`
  margin: 4px 0;
  font-size: 14px;
  line-height: 21px;
  opacity: 0.8;
  ${(props) =>
    props.type === "gain" &&
    css`
      color: #ffffff;
      opacity: 1;
      @media ${device.tablet} {
        font-size: 12px;
        line-height: 18px;
      }
    `};
  ${(props) =>
    props.type === "success" &&
    css`
      color: #008060;
    `};
  ${(props) =>
    props.type === "info" &&
    css`
      color: #084e8a;
    `};
  ${(props) =>
    props.type === "warning" &&
    css`
      color: #c05717;
    `};
`;
export const StyledNotificationButton = styled.button`
  &:hover {
    cursor: pointer;
  }
  padding: 4px 12px;
  border-radius: 4px;
  margin-top: 8px;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #fcfcfd;
  ${(props) =>
    props.notificationType === "gain" &&
    css`
      background: none;
      border: none;
      font-weight: bold;
      font-size: 14px;
      line-height: 21px;
      padding: 0;
      margin-top: 0;
      @media ${device.tablet} {
        font-size: 12px;
        line-height: 18px;
      }
    `};
  ${(props) =>
    props.notificationType === "success" &&
    css`
      background: #008060;
      border: none;
    `};
  ${(props) =>
    props.notificationType === "info" &&
    css`
      background: #084e8a;
      border: none;
    `};
  ${(props) =>
    props.notificationType === "warning" &&
    css`
      background: #c05717;
      border: none;
    `};
`;
export const StyledNotificationInner = styled.div`
  width: 100%;
  margin: 0 16px;

  ${(props) =>
    props.type === "gain" &&
    css`
      margin: 0;
      z-index: 2;
    `};
`;
export const StyledX = styled.span`
  &:hover {
    cursor: pointer;
  }
`;
export const StyledInnerProgressBarNotification = styled.div`
  width: 100%;
  h3 {
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    margin-bottom: 16px;
  }
  p {
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 32px;
  }
  @media ${device.tablet} {
    h3 {
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 8px;
    }
    p {
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      margin-bottom: 16px;
    }
  }
`;

const getProgressBarColor = (value, opacity) => {
  if (value > 80) {
    return `rgb(235, 87, 87, ${opacity})`;
  } else if (value > 50) {
    return `rgb(242, 153, 74, ${opacity})`;
  } else {
    return `rgb(0, 128, 96, ${opacity})`;
  }
};

export const StyledProgressBar = styled.div`
  background: ${(props) => (props.type === "planUsage" ? getProgressBarColor(props.value, 0.2) : "rgb(0, 128, 96, 0.2)")};

  border-radius: 4px;
  padding: 10px;
  margin-bottom: 10px;
  position: relative;
  overflow: hidden;
`;
export const StyledProgressBarFiller = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  padding: 10px 0;
  width: ${(props) => props.value}%;
  background: ${(props) => (props.type === "planUsage" ? getProgressBarColor(props.value, 1) : "rgb(0, 128, 96)")};
`;
export const StyledProgressBarCaption = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  line-height: 21px;
  color: #575e68;
  p {
    margin-bottom: 0;
  }
`;
export const StyledGainSum = styled.div`
  padding: 24px;
  background: #ffffff;
  box-shadow: 0px 28px 32px -30px #074880;
  border-radius: 16px;
  color: #063761;
  text-align: center;
  z-index: 2;
  margin-left: 50px;

  h3 {
    font-weight: 600;
    font-size: 40px;
    line-height: 40px;
  }
  p {
    font-size: 14px;
    line-height: 21px;
    margin-top: 16px;
  }
  @media ${device.tablet} {
    padding: 16px;
    margin-left: 25px;
    h3 {
      font-size: 30px;
      line-height: 30px;
    }
    p {
      font-size: 12px;
      line-height: 16px;
      margin-top: 8px;
    }
  }
  @media ${device.mobileL} {
    width: 100%;
    margin: 1rem 0;
  }
`;
export const StyledPotentialGainBackground = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
`;
